export const apartmentsGlobalSettings = {
  header: {
    title: "Global settings",
    sub: "Applies to <strong>{count} apartment</strong> in your account. | Applies to <strong>{count} apartments</strong> in your account.",
    globalChip: "GLOBAL",
  },
  sections: {
    activate: "Enable the booking engine",
    payment: "When does the guest pay?",
    hold: "Hold time",
    request: "Request mode",
    link: "Link to share",
  },
  motor: {
    activeTitle: "Engine active",
    inactiveTitle: "Engine inactive",
    activeDesc: "Guests can book directly from your link.",
    inactiveDesc: "Direct bookings are turned off for all your apartments.",
    statusOn: "Active",
    statusOff: "Inactive",
  },
  payment: {
    onArrival: {
      name: "Pay on arrival",
      hint: "Book free, pay when you arrive.",
    },
    online: {
      name: "Pay online",
      hint: "Pay when the booking is confirmed.",
    },
  },
  common: {
    saving: "Saving…",
    onlyOnlineBadge: "Online payment only",
  },
  hold: {
    desc: "The calendar is blocked while the guest completes payment.<br>If they don't pay within the set time, <strong>availability is released automatically</strong>.",
  },
  units: {
    min: "min",
    hour: "hour",
    hours: "hours",
  },
  request: {
    enabledTitle: "Requests on",
    autoTitle: "Automatic confirmation",
    enabledDesc: "The guest sends a request. You approve or decline it via WhatsApp.",
    autoDesc: "The booking is confirmed automatically once payment is completed.",
    tagControl: "You control who books",
    tagWhatsapp: "WhatsApp when a request comes in",
  },
  link: {
    desc: "The same link for all your apartments. Share it in your bio, campaigns or automated messages.",
    copyTitle: "Copy",
    viewVisitor: "View as visitor",
    shareWhatsapp: "Share via WhatsApp",
  },
  callout: "Select an apartment in the sidebar to set <strong>Rates</strong>, <strong>Promotions</strong> and <strong>Charges</strong> individually.",
  savebar: {
    unsaved: "Unsaved hold and request-mode changes",
    save: "Save settings",
  },
  toasts: {
    paymentUpdated: "Payment method updated.",
    paymentError: "Couldn't save the payment method.",
    saved: "Settings saved.",
    saveError: "Couldn't save.",
    linkCopied: "Link copied.",
    copyError: "Couldn't copy.",
  },
  share: {
    whatsappText: "Hi 👋 Here's the link to book: {link}",
  },
};
